<template>
    <b-modal v-model="modalShow" ref="modal-cancel" size="sm" title="Contemplate Proposta">
        <b-form novalidate="novalidate" autocomplete="off">
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group bmd-form-group is-filled"
                         v-bind:class="{'has-danger' : validation.contemplate_at != ''}">
                        <label for="cancel_at" class="bmd-label-floating">Data</label>
                        <date-picker v-model="form.contemplate_at" lang="pt-br" format="DD/MM/YYYY" placeholder="Escolha uma data"></date-picker>
                        <label v-if="validation.contemplate_at != ''" id="contemplate_at-error" class="error" for="contemplate_at">{{ validation.contemplate_at }}</label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group bmd-form-group is-filled"
                         v-bind:class="{'has-danger' : validation.type_contemplation != ''}">
                        <label for="cancel_at" class="bmd-label-floating">Tipo de Contemplação</label>
                        <model-list-select
                            class="form-control"
                            :list="contemplation_types"
                            option-value="id"
                            option-text="name"
                            v-model="form.type_contemplation">
                        </model-list-select>
                        <label v-if="validation.type_contemplation != ''" id="type_contemplation-error" class="error" for="type_contemplation">{{ validation.type_contemplation }}</label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group bmd-form-group"
                         v-bind:class="{'has-danger' : validation.observations != ''}">
                        <b-form-textarea
                            id="textarea"
                            v-model="form.observations"
                            placeholder="Observações..."
                            rows="3"
                            max-rows="6"
                            :state="validation.observations == ''"
                            ></b-form-textarea>
                        <label v-if="validation.observations != ''" id="observations-error" class="error" for="observations">{{ validation.observations }}</label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="form-check bmd-form-group is-filled">
                        <label class="bmd-label-floating">Pagou boleto?</label>
                        <b-form-checkbox
                            id="paid_billet"
                            v-model="form.paid_billet"
                            :value="true"
                            :unchecked-value="false">
                            {{ form.paid_billet ? 'Sim': 'Não' }}
                        </b-form-checkbox>
                    </div>
                </div>
            </div>
        </b-form>
        <div slot="modal-footer">
            <button @click="onSubmitContemplate" class="btn btn-rose btn-sm">
                <span class="btn-label">
                    <i class="material-icons">done</i>
                </span>
                Salvar
            </button>
            <b-button @click="goBack" size="sm">
                <span class="btn-label">
                    <i class="material-icons">{{ 'keyboard_arrow_left' }}</i>
                </span>
                {{ 'Voltar' }}
            </b-button> 
        </div>
    </b-modal>
</template>
<script>
    export default {
        data() {
            return {
                contemplation_types: [
                    {
                        id: "L",
                        name: "Lance"
                    },
                    {
                        id: "S",
                        name: "Sorteio"
                    }
                ],
                form: {
                    id: 0,
                    contemplate_at: '',
                    observations: '',
                    paid_billet: '',
                    proposal_status_id: 3,
                    type_contemplation: '',
                },
                modalShow: true,
                validation: {
                    contemplate_at: '',
                    observations: '',
                    type_contemplation: '',
                }
            };
        },
        mounted() {
            var self = this;

            self.form.id = self.$route.params.id;

            self.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
                self.goBack();
            });
        },
        methods: {
            goBack() {
                var self = this;
                self.$router.push({'name': 'proposals.show', params: {'id': self.$route.params.id}});
            },
            onSubmitContemplate(_ev) {
                var self = this;
                var valid = true;

                self.validation = {
                    contemplate_at: '',
                    observations: '',
                    type_contemplation: '',
                };

                _ev.preventDefault();

                if (self.form.contemplate_at == '') {
                    self.validation.contemplate_at = "Campo obrigatório!";
                    valid = false;
                }

                if (self.form.type_contemplation == '') {
                    self.validation.type_contemplation = "Campo obrigatório!";
                    valid = false;
                }

                if (self.form.observations == '') {
                    self.validation.observations = "Campo obrigatório!";
                    valid = false;
                }

                if (valid) {
                    self.$root.$emit("onLoading");

                    const response = self.$store.dispatch('proposals/edit', self.form);

                    response.then(function () {
                        self.$root.$emit("onLoading");
                        self.$notify.success("Proposta contemplada com sucesso!");
                        self.goBack();
                    });

                    response.catch(function (err) {
                        self.$root.$emit("onLoading");
                        if (err.status === 406 || err.status === 422) {
                            if (err.data.invoice_at !== undefined) {
                                self.validation.invoice_at = err.data.invoice_at[0];
                            }
                            if (err.data.observations !== undefined) {
                                self.validation.observations = err.data.observations[0];
                            }
                        }
                    });
                }
            }
        }
    };
</script>